module.exports = __webpack_public_path__ + "img/account.b1cc3349.svg";